import React from 'react'

import ReportTable from '../report_table'
import { formatReportDate, localeNumberFormatter } from '../helpers'

// port of cowebapp analytics/components/prospect/report_individual_table.js
const ReportTableIndividual = (props) => {

  const noDataIndication = () => {
    return (
      <div
        className="list-container text-center bg-white"
        style={{ padding: '10px' }}
      >
        <p className="m-0">
          No Activity Found
        </p>
      </div>
    )
  }

  const dateFormatter = (cell) => {
    return formatReportDate(cell, props.userReportData.breakdown)
  }

  const getTableData = () => {
    let tableData = []
    let tmp = props.tableData && props.tableData[0] && props.tableData[0].stats ? props.tableData[0].stats : props.tableData
    tmp.forEach((data) => {
      if (data.total_billable_lead > 0) {
        tableData.push(data)
      }
    })

    return tableData
  }

  const data = getTableData()
  const formatNumber = localeNumberFormatter('0')
  const colWidth = { width: '20%' }

  const columns = [
    {
      dataField: 'date',
      text: 'Day',
      formatter: dateFormatter,
      headerStyle: colWidth,
      style: colWidth,
    },
    {
      dataField: 'total_billable_lead',
      text: 'Total Prospects',
      headerStyle: colWidth,
      style: colWidth,
      formatter: formatNumber,
      align: 'right',
      sort: true,
      headerTitle: () => 'Total Prospects'
    },
    {
      dataField: 'total_email_credits',
      text: 'Email Enrichment Credits',
      headerStyle: colWidth,
      style: colWidth,
      formatter: formatNumber,
      align: 'right',
      sort: true,
      headerTitle: () => 'Email Enrichment Credits'
    },
    {
      dataField: 'total_phone_credits',
      text: 'Phone Enrichment Credits',
      headerStyle: colWidth,
      style: colWidth,
      formatter: formatNumber,
      align: 'right',
      sort: true,
      headerTitle: () => 'Phone Enrichment Credits'
    },
    {
      dataField: 'total_credits_charged',
      text: 'Billable Credits',
      headerStyle: colWidth,
      style: colWidth,
      formatter: formatNumber,
      align: 'right',
      sort: true
    }
  ]

  return (
    <div className="report-table">
      <ReportTable
        keyField="date"
        data={data}
        columns={columns}
        wrapperClasses="table-report table-responsive"
        noDataIndication={noDataIndication}
      />
    </div>
  )
}

export default ReportTableIndividual
